export const externalLinks = {
  github: 'https://github.com/Adam262',
  linkedin: 'https://www.linkedin.com/in/adambarcan/',
  instagram: 'https://www.instagram.com/barcanshoot/',
  medium: 'https://medium.com/@adambarcan',
  strava: 'https://www.strava.com/athletes/3953675',
  photoPortfolio: 'https://photo.adambarcan.com',
}

export const myEmail = "hello@adambarcan.com"



// WEBPACK FOOTER //
// ./src/constants.js